const purchaseTemplate = `
 <div className="mt-2">
  <p><strong style="color: rgb(16, 65, 130);">Contexte : </strong></p>
  <ul>
    <li>Acteur majeur du SECTEUR, le Groupe XXX offre à l'ensemble de ses points de vente, via XXX (filiale),
      des solutions informatiques...
    </li>
    <li>Intervention au sein du département Achat Logiciel, dans le cadre de la réorganisation du pôle.</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Périmètre :</strong></p>
  <ul>
    <li>Prestations intellectuelles</li>
    <li>Logiciels</li>
    <li>Hardware</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Fournisseurs principaux :</strong></p>
  <ul>
    <li>Microsoft, VMWARE, EMC, Orange, Sungard, Bloomberg, HP, IBM, Oracle, Sap, etc.</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Objectif :</strong></p>
  <ul>
    <li>Objectif 1</li>
    <li>Objectif 2</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Réalisations :</strong></p>
  <ul>
    <li>Gérer les achats de PII en mode AT - Profils MOA/MOE</li>
    <li>Négocier les conditions tarifaires et contractuelles avec les fournisseurs</li>
    <li>Rédaction des contrats et des avenants</li>
    <li>Vérification, mise en oeuvre et suivi des contrats en signature</li>
    <li>Traiter les litiges avec les fournisseurs</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Résultats :</strong></p>
  <ul>
    <li>10% de savings sur ...</li>
    <li>4 recrutements en 6 mois</li>
    <li>SLA monté de 90 à 98% en 3 mois</li>
  </ul>
</div>
`

export {purchaseTemplate}